export interface IProductSubCategory {
  name: string;
  description: string;
  imgSrc?: string;
}

export interface IProductCategory {
  name: string;
  description: string;
  imgSrc: string;
  subCategories: IProductSubCategory[];
}

export const productCategoryInitialState: IProductCategory[] = [
  {
    name: "Supplements (Adults)",
    description:
      "Premium dietary supplements designed to optimize health, energy, and longevity.",
    imgSrc: require("../../assets/images/product-categories/multivitamins-gummies.png"),
    subCategories: [
      {
        name: "Collagen",
        description:
          "Support for skin elasticity, joint health, and bone density.",
      },
      {
        name: "Glutathione",
        description:
          "Master antioxidant for cellular protection and skin brightening.",
      },
      {
        name: "Vitamin C",
        description: "Essential immune support and antioxidant defense.",
      },
      {
        name: "Vitamin D",
        description:
          "The sunshine vitamin for bone health and immune regulation.",
      },
      {
        name: "NAD+",
        description: "Coenzymes for cellular energy production and DNA repair.",
      },
      {
        name: "Blood-support supplements",
        description:
          "Formulas designed to support iron levels and cardiovascular health.",
      },
      {
        name: "Anti-aging & longevity",
        description:
          "Targeted nutrients to support healthy aging and vitality.",
      },
    ],
  },
  {
    name: "Skincare",
    description:
      "Science-backed dermatological solutions for a radiant and healthy complexion.",
    imgSrc: require("../../assets/images/product-categories/skin-care-1.jpg"),
    subCategories: [
      {
        name: "Hyaluronic acid products",
        description:
          "Deep hydration and moisture retention for all skin types.",
      },
      {
        name: "Vitamin C serums",
        description:
          "Brightening formulas to even skin tone and boost collagen.",
      },
      {
        name: "Retinoids",
        description:
          "Potent Vitamin A derivatives for anti-aging and skin renewal.",
      },
      {
        name: "Niacinamide",
        description:
          "Vitamin B3 to refine pores and strengthen the skin barrier.",
      },
      {
        name: "Cleansers & Moisturizers",
        description: "Essential daily staples for clean, balanced skin.",
      },
    ],
  },
  {
    name: "Supplements (Children)",
    description: "Safe and effective nutritional support for growing children.",
    imgSrc: require("../../assets/images/product-categories/kid-supplements.png"),
    subCategories: [
      {
        name: "Multivitamins",
        description:
          "Comprehensive daily nutrients for physical and cognitive development.",
      },
      {
        name: "Omega-3",
        description: "Essential fatty acids for brain health and focus.",
      },
      {
        name: "Immune & growth support",
        description:
          "Targeted formulas to strengthen natural defenses and healthy growth.",
      },
    ],
  },
  {
    name: "Postpartum Care",
    description:
      "Essential recovery kits and wellness products for new mothers.",
    imgSrc: require("../../assets/images/product-categories/post-partum-care-2.webp"),
    subCategories: [
      {
        name: "Postpartum care kits",
        description: "Complete recovery sets for the fourth trimester.",
      },
      {
        name: "Perineal & Cooling pads",
        description: "Immediate soothing relief for vaginal recovery.",
      },
      {
        name: "Witch hazel products",
        description: "Natural astringents for gentle healing and comfort.",
      },
      {
        name: "Breastfeeding & Motherhood",
        description: "Support items for lactation and maternal wellness.",
      },
      {
        name: "C-Section Recovery",
        description:
          "Specialized care for abdominal incision healing and comfort.",
      },
    ],
  },
];
